/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MyReward } from './MyReward';
import {
    MyRewardFromJSON,
    MyRewardFromJSONTyped,
    MyRewardToJSON,
    MyRewardToJSONTyped,
} from './MyReward';

/**
 * 
 * @export
 * @interface MyRewardsResponse
 */
export interface MyRewardsResponse {
    /**
     * 
     * @type {Array<MyReward>}
     * @memberof MyRewardsResponse
     */
    rewards: Array<MyReward>;
    /**
     * 
     * @type {number}
     * @memberof MyRewardsResponse
     */
    total: number;
}

/**
 * Check if a given object implements the MyRewardsResponse interface.
 */
export function instanceOfMyRewardsResponse(value: object): value is MyRewardsResponse {
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function MyRewardsResponseFromJSON(json: any): MyRewardsResponse {
    return MyRewardsResponseFromJSONTyped(json, false);
}

export function MyRewardsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyRewardsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rewards': ((json['rewards'] as Array<any>).map(MyRewardFromJSON)),
        'total': json['total'],
    };
}

export function MyRewardsResponseToJSON(json: any): MyRewardsResponse {
    return MyRewardsResponseToJSONTyped(json, false);
}

export function MyRewardsResponseToJSONTyped(value?: MyRewardsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rewards': ((value['rewards'] as Array<any>).map(MyRewardToJSON)),
        'total': value['total'],
    };
}

